import { useCalculationMetricTableQuery } from 'generated/graphql';
import { CalculationMetricTableRow } from 'modules/components/layer22';
import { useMemo } from 'react';



export type IData = {
  calculations: CalculationMetricTableRow.CalculationDataObject[];
};

export function useQuery(listedCompanyId: string) {
  const tuple = useCalculationMetricTableQuery({
    skip: !listedCompanyId,
    variables: {
      listedCompanyId
    }
  });



  return useMemo(
    () => {
      const data: IData = {
        calculations: tuple.data?.listedCompany?.calculations?.map((node): CalculationMetricTableRow.CalculationDataObject => ({
          id: node.id ?? '',
          formula: node.formula.displayName ?? '',
          inputs: node.inputs,
          isEnabled: node.isEnabled,
          metric: node.metric,
          output: node.outputValue,
          unit: node.unit,
          formattedValue: node.formattedValue,
          sentiment: node.sentiment,
          badSentimentDescription: node.badSentimentDescription,
          calculationDescription: node.calculationDescription,
          goodSentimentDescription: node.goodSentimentDescription,
          neutralSentimentDescription: node.neutralSentimentDescription,
          nmfSentimentDescription: node.nmfSentimentDescription,
          summary: node.sentimentSummary
        })) ?? []
      };

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}
